import { render, staticRenderFns } from "./CellRendererDataAI.vue?vue&type=template&id=5403f5fa&scoped=true"
import script from "./CellRendererDataAI.vue?vue&type=script&lang=js"
export * from "./CellRendererDataAI.vue?vue&type=script&lang=js"
import style0 from "./CellRendererDataAI.vue?vue&type=style&index=0&id=5403f5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5403f5fa",
  null
  
)

export default component.exports